import { config } from '@app/config';
import { getApiV2Client, getSegmentsGetHlsLivePlaylistUrl } from '@mi-front/api-v2';
import { useMemo, useState } from 'react';

/**
 * Builds the live HLS playlist URL for a station.
 * Appends a mount-stable `liveSessionId` so the backend can correlate playlist reloads
 * within the same player session.
 */
export function useStationLiveHlsUrl(stationId: string) {
  const [liveSessionId] = useState(() => crypto.randomUUID());

  const src = useMemo(() => {
    if (!stationId) {
      return;
    }

    const { url } = getSegmentsGetHlsLivePlaylistUrl(stationId);

    return getApiV2Client().generateUrl(`${config.apiV2Root}${url}`, {
      prependBaseURL: false,
      secure: true,
      params: { windowSeconds: 90, liveSessionId },
    });
  }, [stationId, liveSessionId]);

  return src;
}
